import Image from 'next/image';
import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function HomeCompaniesDark() {
  const COMPANIES = [
    {
      name: 'Naresh i Technologies',
      logo: '/assets/pastwork/nareshIT.png',
      width: 140,
      height: 80,
    },
    {
      name: 'Titan Company',
      logo: '/assets/pastwork/titan.png',
      width: 140,
      height: 80,
    },
  ];

  // Repeat each company twice
  const repeatedCompanies = COMPANIES.flatMap((company) => [company, company]);

  return (
    <Box
      sx={{
        textAlign: 'center',
        bgcolor: 'grey.900',
        pt: { xs: 10, md: 15 },
        pb: { xs: 10, md: 20 },
      }}
    >
      <Container component={MotionViewport}>
        <Stack alignItems="center" spacing={6}>
          <m.div variants={varFade().inUp}>
            <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 1.2 }}>
              Companies I’ve Worked With
            </Typography>
          </m.div>
          <Box
            component={m.div}
            variants={varFade().inUp}
            display="grid"
            gap={{ xs: 3, md: 5 }}
            gridTemplateColumns={{
              xs: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(4, 1fr)',
            }}
          >
            {repeatedCompanies.map((company, index) => (
              <Box
                key={`${company.name}-${index}`}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Image
                  alt={company.name}
                  src={company.logo}
                  width={company.width}
                  height={company.height}
                  style={{ maxWidth: '140px', height: 'auto', opacity: 0.85 }}
                />
              </Box>
            ))}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
